import http from "@/settings/apiSettings"

class PORTAL_AprobariService {
  getPending(): Promise<any> {
    return http.clientPortalHR.get("/portal/aprobari-pending", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  aprobare(id: string, tipCerere: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/aprobari/${id}/aprobare`, { TipCerere: tipCerere, Observatie: observatie }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  respingere(id: string, tipCerere: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/aprobari/${id}/respingere`, { TipCerere: tipCerere, Observatie: observatie }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getInlocuitorPending(): Promise<any> {
    return http.clientPortalHR.get("/portal/inlocuitor-pending", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getInlocuitorPendingTichete(): Promise<any> {
    return http.clientPortalHR.get("/portal/inlocuitor-pending-tichete", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  confirmaInlocuitor(id: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/inlocuitor/${id}/confirma`, { Observatie: observatie }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_AprobariService();
